import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { from, Observable, throwError } from 'rxjs'
import { map, catchError } from 'rxjs/operators'
import { eps } from './url.service' //Endpoints
import { AuthState, User } from '../store/auth/auth.state'
import { getMessaging, getToken } from 'firebase/messaging'
import { environment } from '../../environments/environment'
import { UtilsService } from './utils.service'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http = inject(HttpClient) // Use inject() instead of constructor injection
  private authApis = eps.auth
  constructor(private utilsService: UtilsService) {}
  // login(email: string, password: string): Observable<AuthState> {
  //   const deviceInfo = this.getDeviceInfo()
  //   const deviceToken = localStorage.getItem('fcmToken') || this.generateToken() || ''

  //   const payload = {
  //     email,
  //     password,
  //     deviceType: deviceInfo.deviceType,
  //     deviceInfo: `${deviceInfo.platform} - ${deviceInfo.userAgent}`,
  //     //deviceToken,
  //     loginTime: new Date().toISOString()
  //   }
  //   return this.http.post<AuthState>(this.authApis.loginApi, payload).pipe(
  //     map(response => response),
  //     catchError(error => throwError(() => error))
  //   )

  //   // return this.http.post<AuthState>(this.authApis.loginApi, { email, password }).pipe(
  //   //   map(response => response),
  //   //   catchError(error => throwError(() => error))
  //   // )
  // }

  // login(email: string, password: string): Observable<AuthState> {
  //   return from(this.performLogin(email, password))
  // }

  login(email: string, password: string): Observable<AuthState> {
    return from(this.loginWithFcmToken(email, password))
  }

  private async loginWithFcmToken(email: string, password: string): Promise<AuthState> {
    await this.generateAndStoreFcmToken()
    return this.performLogin(email, password)
  }

  private async performLogin(email: string, password: string): Promise<AuthState> {
    const deviceInfo = this.utilsService.getDeviceInfo()
    const deviceToken = localStorage.getItem('fcmToken') || this.utilsService.generateToken() || ''
    const location = await this.utilsService.getLocation()

    const payload = {
      email,
      password,
      deviceType: deviceInfo.deviceType,
      deviceInfo: `${deviceInfo.platform} - ${deviceInfo.userAgent}`,
      deviceToken,
      loginTime: new Date().toISOString(),
      loginLatitude: location?.latitude ?? null,
      loginLongitude: location?.longitude ?? null
    }
    // console.log('angular payload', payload)

    return this.http
      .post<AuthState>(this.authApis.loginApi, payload)
      .pipe(
        map(response => {
          if (!response) throw new Error('No response from login API')
          return response
        }),
        catchError(error => throwError(() => error))
      )
      .toPromise() as Promise<AuthState>
  }

  getImage(imageUrl: string): Observable<Blob> {
    return this.http.get(imageUrl, { responseType: 'blob' })
  }

  register(user: {
    firstName: string
    lastName: string
    email: string
    mobile: string
    businessName: string
    planId: string
  }): Observable<User> {
    return this.http.post<User>(this.authApis.registerApi, user).pipe(
      map(response => response),
      catchError(error => throwError(() => error))
    )
  }

  /**
   * Sends the forgot password request to the backend with the user's email.
   * @param email - The email address of the user to send the reset password link to.
   * @returns An observable with the response from the backend.
   */
  forgotPassword(email: { email: string }): Observable<any> {
    return this.http.post(this.authApis.forgotPasswordApi, email).pipe(
      catchError(error => {
        // Log the error message or handle it as needed
        console.error('Error updating clock-in/clock-out:', error)

        // Check if the error has a message and rethrow it with the message
        if (error.error && error.error.message) {
          return throwError(() => new Error(error.error.message))
        } else {
          return throwError(() => new Error('Unknown error occurred'))
        }
      })
    )
  }

  /**
   * Resets the user's password using the token and new password.
   * @param data - Contains the reset token and new password.
   * @returns An observable with the response from the backend.
   */
  resetPassword(data: { token: string; email: string; password: string }): Observable<any> {
    return this.http.post(this.authApis.resetPasswordApi, data)
  }

  refreshToken() {
    const refreshToken = localStorage.getItem('refreshToken')
    return this.http.post<{ accessToken: string; user: User; refreshToken: string }>(
      this.authApis.refreshTokenApi,
      {
        refreshToken
      }
    )
  }

  getCurrentUser(): Observable<AuthState> {
    return this.http.get<AuthState>(`${eps.user.userApi}/me`)
  }

  // private getDeviceInfo() {
  //   const userAgent = navigator.userAgent
  //   const platform = navigator.platform
  //   const deviceType = /mobile/i.test(userAgent)
  //     ? 'Mobile'
  //     : /tablet|ipad/i.test(userAgent)
  //       ? 'Tablet'
  //       : 'Desktop'

  //   return {
  //     userAgent,
  //     platform,
  //     deviceType
  //   }
  // }

  // generateToken(): string {
  //   const token = crypto.randomUUID()
  //   localStorage.setItem('device_token', token)
  //   return token
  // }
  // generateToken(): string {
  //   if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
  //     const bytes = new Uint8Array(16)
  //     crypto.getRandomValues(bytes)

  //     // Format to UUID v4
  //     bytes[6] = (bytes[6] & 0x0f) | 0x40
  //     bytes[8] = (bytes[8] & 0x3f) | 0x80

  //     const token = [...bytes]
  //       .map(
  //         (b, i) =>
  //           (i === 4 || i === 6 || i === 8 || i === 10 ? '-' : '') + b.toString(16).padStart(2, '0')
  //       )
  //       .join('')

  //     localStorage.setItem('device_token', token)
  //     return token
  //   } else {
  //     // fallback if crypto not available
  //     const token = 'xxxxxxxyxxxxxxxxyxxxxxyxxxxyxxxyx'.replace(/[xy]/g, c => {
  //       const r = (Math.random() * 16) | 0
  //       const v = c === 'x' ? r : (r & 0x3) | 0x8
  //       return v.toString(16)
  //     })
  //     localStorage.setItem('device_token', token)
  //     return token
  //   }
  // }

  // getUserLocation(): Promise<{ latitude: number; longitude: number } | null> {
  //   return new Promise((resolve, reject) => {
  //     if (!navigator.geolocation) return resolve(null)

  //     navigator.geolocation.getCurrentPosition(
  //       position => {
  //         resolve({
  //           latitude: position.coords.latitude,
  //           longitude: position.coords.longitude
  //         })
  //       },
  //       error => {
  //         console.warn('Geolocation error:', error)
  //         resolve(null) // fallback to null if denied or failed
  //       },
  //       { enableHighAccuracy: true }
  //     )
  //   })
  // }

  getUserLocation(): Promise<{ latitude: number; longitude: number } | null> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        return resolve(null)
      }

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            const latitude = position.coords.latitude
            const longitude = position.coords.longitude
            console.log('Latitude:', latitude, 'Longitude:', longitude)
          },
          error => {
            console.error('Error getting location:', error)
          },
          {
            enableHighAccuracy: true, // Requests GPS
            timeout: 10000, // Max wait time
            maximumAge: 0 // No cached position
          }
        )
      } else {
        console.error('Geolocation is not supported by this browser.')
      }
    })
  }

  getCurrentPosition(): Observable<GeolocationPosition> {
    return new Observable(observer => {
      if (!navigator.geolocation) {
        observer.error('Geolocation is not supported by your browser.')
        return
      }

      navigator.geolocation.getCurrentPosition(
        position => {
          observer.next(position)
          observer.complete()
        },
        error => {
          console.error('Geolocation error:', error.message)
          observer.error(error)
        },
        { enableHighAccuracy: true }
      )
    })
  }

  // getLocation() {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position: Position) => {
  //         if (position) {
  //           console.log(
  //             'Latitude: ' + position.coords.latitude + 'Longitude: ' + position.coords.longitude
  //           )
  //           this.lat = position.coords.latitude
  //           this.lng = position.coords.longitude
  //           console.log(this.lat)
  //           console.log(this.lat)
  //         }
  //       },
  //       (error: PositionError) => console.log(error)
  //     )
  //   } else {
  //     alert('Geolocation is not supported by this browser.')
  //   }
  // }

  // getLocation() {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position: any) => {
  //         if (position) {
  //           console.log(
  //             'Latitude: ' + position.coords.latitude + 'Longitude: ' + position.coords.longitude
  //           )
  //           this.lat = position.coords.latitude
  //           this.lng = position.coords.longitude
  //           // console.log(this.lat)
  //           // console.log(this.lat)
  //         }
  //       },
  //       (error: any) => console.log(error)
  //     )
  //   } else {
  //     alert('Geolocation is not supported by this browser.')
  //   }
  // }

  // getLocation(): Promise<{ latitude: number; longitude: number } | null> {
  //   return new Promise((resolve, reject) => {
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(
  //         position => {
  //           if (position) {
  //             console.log(
  //               'Latitude:',
  //               position.coords.latitude,
  //               'Longitude:',
  //               position.coords.longitude
  //             )
  //             resolve({
  //               latitude: position.coords.latitude,
  //               longitude: position.coords.longitude
  //             })
  //           } else {
  //             resolve(null)
  //           }
  //         },
  //         error => {
  //           console.error('Geolocation error:', error)
  //           resolve(null) // Resolve as null on error instead of rejecting
  //         }
  //       )
  //     } else {
  //       console.warn('Geolocation is not supported by this browser.')
  //       resolve(null)
  //     }
  //   })
  // }

  validateResetToken(token: string, email: string): Observable<{ valid: boolean }> {
    return this.http.get<{ valid: boolean }>(
      `${this.authApis.validateResetTokenApi}?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`
    )
  }

  async generateAndStoreFcmToken(): Promise<string | null> {
    try {
      const messaging = getMessaging()
      const currentToken = await getToken(messaging, {
        vapidKey: environment.vapidKey
      })

      if (currentToken.length > 100) {
        localStorage.setItem('fcmToken', currentToken)
        return currentToken
      } else {
        console.warn('No FCM token retrieved')
        return null
      }
    } catch (err) {
      console.error('Unable to get FCM token', err)
      return null
    }
  }

  logout() {
    // if API call exists
    return this.http.patch<any>(this.authApis.logoutApi, {})

    // OR if no API call is needed:
    // return of({ success: 'Logged out' })
  }

  // logout(): Observable<any> {
  //   return this.http.post<any>(this.authApis.logoutApi).pipe(
  //     map(response => response),
  //     catchError(error => throwError(() => error))
  //   )
  // }
}
